<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="update">
            <b-form-group :label="$t('person.login')" label-cols-sm="3">
                <b-form-input v-model="formData.login" required disabled></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.newPassword')" label-cols-sm="3">
                <b-form-input v-model="formData.newPassword" :state="isValid"></b-form-input>
                <b-form-text id="inputLiveHelp">
                    {{ $t('person.passwordRequirements') }}
                </b-form-text>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>
<script>
/* eslint-disable */
import AppData from '@/utils/appdata'
import { isPasswordValid } from '../../validators/FormValidators';

export default {
    name: 'PersonChangePasswordForm',
    mixins: [ AppData ],
    props: {
        personId: Number
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                login: null,
                newLogin: null,
                newPassword: null
            }
        }
    },
    mounted () {
        this.fetchFormData()
    },
    computed: {
        isValid() {
            if (this.formData.newPassword === null)
                return null;

            return isPasswordValid(this.formData.newPassword);
        }
    },
    methods: {
        fetchFormData() {
            const onSuccess = response => {
                this.formData.login = response[0].login;
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.person.getAll,
                { id: this.personId },
                onSuccess,
                this.displayAlert);
        },
        update() {
            this.hideAlert();
            if (!this.isValid) {
                this.displayAlert('passwordNotValid');
                return;
            }

            const onSuccess = response => {
                this.showSuccessAlert = true;
                this.alert = this.$i18n.t('person.updatedMessage');
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.person.update,
                this.formData, 
                onSuccess, 
                this.displayAlert);
        }
    }
}
</script>
